import { BalanceAdjustmentService } from 'src/app/angularJS/services/balance-adjustment/balance-adjustment.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { ChargeAccountActionsService } from 'src/app/angularJS/services/charge-account-actions/charge-account-actions.service';
import { ChargeAccountAutoTopupService } from 'src/app/angularJS/services/charge-account-auto-topup/charge-account-auto-topup.service';
import { ChargeAccountDeviceMappingsService } from 'src/app/angularJS/services/charge-account-device-mappings/charge-account-device-mappings.service';
import { ChargeAccountService } from 'src/app/angularJS/services/charge-account/charge-account.service';
import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { DebtRecoveryService } from 'src/app/angularJS/services/debt-recovery/debt-recovery.service';
import { DialogService } from 'src/app/angularJS/services/dialog/dialog.service';
import { ExternalTopUpsService } from 'src/app/angularJS/services/external-top-ups/external-top-ups.service';
import { JourneyService } from 'src/app/angularJS/services/journey/journey.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { PaymentService } from 'src/app/angularJS/services/payments/payments.service';
import { PhotoService } from 'src/app/angularJS/services/photo/photo.service';
import { ProductService } from 'src/app/angularJS/services/product/product.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { SecureUsageTokenService } from 'src/app/angularJS/services/secure-usage-token/secure-usage-token.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { UsageEventService } from 'src/app/angularJS/services/usage-event/usage-event.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { NumberUtils } from './../../../../utils/number-utils';
import { IAutoTopupRules } from 'src/app/interfaces/client-only/IAutoTopupRules';
import { ChargeAccountBaseComponent } from '../charge-account-base.component';

/**
 * A class containing properties and methods relating to a charge account summary
 */
export class ChargeAccountSummaryController extends ChargeAccountBaseComponent {
  public static $inject = [
    'chargeAccountResponse',
    'breadcrumbService',
    'customerService',
    'ACTToolbarService',
    'userService',
    '$state',
    '$translate',
    'paymentService',
    'productService',
    'journeyService',
    'usageEventService',
    'photoService',
    '$window',
    'QueryBuilder',
    'dialogService',
    'chargeAccountActionsService',
    'LinkBuilder',
    'UserMessages',
    'debtRecoveryService',
    'secureUsageTokenService',
    '$rootScope',
    'externalTopUpsService',
    'chargeAccountService',
    'chargeAccountAutoTopupService',
    'balanceAdjustmentService',
    'chargeAccountDeviceMappingsService'
  ];

  public recentPayments: Array<InterACT.Interfaces.Payments.PaymentRequest> = [];
  public recentUsages: Array<InterACT.Interfaces.Journeys.Journey> = [];
  public recentJourneys: Array<InterACT.Interfaces.Journeys.Journey> = [];
  public chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount;
  public paymentToken: InterACT.Interfaces.Payments.PaymentToken;
  public lastModifiedDateOfPaymentToken: string;
  public journeyToUsageEventDictionary: InterACT.Interfaces.IDictionary<Array<InterACT.Interfaces.UsageEvents.UsageEvent>> = {};
  public customer: InterACT.Interfaces.Customers.Customer;
  public customerPhoto = '../../assets/images/user.png';
  public retrievingCustomer = false;
  public mostRecentPayment: InterACT.Interfaces.Payments.PaymentRequest;
  public lastActionWithMeta: InterACT.Interfaces.ChargeAccounts.ChargeAccountActionWithMeta;
  public journeys: Array<InterACT.Interfaces.Journeys.Journey> = [];
  public expandedItem: InterACT.Interfaces.Journeys.Journey;
  public chargeAccountType: string;
  public latestUsageTokenId: string;
  public displayLastPaymentActivity: boolean;
  public displayLastBalanceActivity: boolean;
  public isAutoTopupEnabled: boolean;
  public autoTopupStatus: string;
  public chargeAccountDeviceMapping: InterACT.Interfaces.ChargeAccounts.ChargeAccountDeviceMapping;
  public displayDevice: boolean;

  private autoTopupRules: IAutoTopupRules;

  constructor(
    public chargeAccountResponse: InterACT.Interfaces.ChargeAccounts.ChargeAccountResponse,
    public breadcrumbService: BreadcrumbService,
    public customerService: CustomerService,
    public ACTToolbarService: ACTToolbarService,
    public userService: UserService,
    public $state: ng.ui.IStateService,
    public $translate: ng.translate.ITranslateService,
    private paymentService: PaymentService,
    private productService: ProductService,
    private journeyService: JourneyService,
    private usageEventService: UsageEventService,
    private photoService: PhotoService,
    private $window: ng.IWindowService,
    private queryBuilder: QueryBuilder,
    private dialogService: DialogService,
    private chargeAccountActionsService: ChargeAccountActionsService,
    private linkBuilder: LinkBuilder,
    private userMessagesService: UserMessagesService,
    private debtRecoveryService: DebtRecoveryService,
    private secureUsageTokenService: SecureUsageTokenService,
    private $rootScope: InterACT.Interfaces.IActoraRootScope,
    private externalTopUpsService: ExternalTopUpsService,
    private chargeAccountService: ChargeAccountService,
    private chargeAccountAutoTopupService: ChargeAccountAutoTopupService,
    private balanceAdjustmentService: BalanceAdjustmentService,
    private chargeAccountDeviceMappingsService: ChargeAccountDeviceMappingsService
  ) {
    super(chargeAccountResponse.chargeAccount, breadcrumbService, customerService, ACTToolbarService, userService, $state, $translate);
    this.chargeAccount = chargeAccountResponse.chargeAccount;
    this.activate();
  }

  /**
   * A method that blocks the charge account
   */
  public blockChargeAccount = () => {
    this.dialogService.showChargeAccountActionsDialog('BLOCK').then((blockReason) => {
      const chargeAccountAction: InterACT.Interfaces.ChargeAccounts.ChargeAccountAction = {
        scheme: {
          link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id),
          abbreviation: this.userService.selectedScheme.reference
        },
        chargeAccount: {
          link: this.linkBuilder.getChargeAccountLink(this.chargeAccount.id)
        },
        actionType: 'BLOCK',
        reason: blockReason.reason,
        comment: blockReason.comments
      };

      this.chargeAccountActionsService.create(chargeAccountAction).then(() => {
        this.userMessagesService.showToast(this.$translate.instant('BLOCK_ACCOUNT_DIALOG.BLOCK_SUCCESS'));
        this.getLastAction();
      });
    });
  };

  /**
 * A method that unblocks the charge account
 */
  public unblockChargeAccount = () => {
    this.dialogService.showChargeAccountActionsDialog('UNBLOCK').then((unblockReason) => {
      const chargeAccountAction: InterACT.Interfaces.ChargeAccounts.ChargeAccountAction = {
        scheme: {
          link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id),
          abbreviation: this.userService.selectedScheme.reference
        },
        chargeAccount: {
          link: this.linkBuilder.getChargeAccountLink(this.chargeAccount.id)
        },
        actionType: 'UNBLOCK',
        reason: unblockReason.reason,
        comment: unblockReason.comments
      };

      this.chargeAccountActionsService.create(chargeAccountAction).then(() => {
        this.userMessagesService.showToast(this.$translate.instant('BLOCK_ACCOUNT_DIALOG.UNBLOCK_SUCCESS'));
        this.getLastAction();
      });
    });
  };


  /**
   * A method that shows a remove balance dialog
   */
  public showRemoveCreditDialog = () => {
    this.dialogService.showRemoveCreditDialog(this.chargeAccount.creditBalance).then((data: { amount: number }) => {
      this.$rootScope.showSpinner = true;

      const balanceAdjustment: InterACT.Interfaces.ChargeAccounts.BalanceAdjustment = {
        transactionType: 'DECREMENT',
        amount: NumberUtils.round(data.amount),
        scheme: this.chargeAccount.scheme,
        customer: this.chargeAccount.customer,
        chargeAccount: {
          link: this.linkBuilder.getChargeAccountLink(this.chargeAccount.id)
        },
        status: 'PENDING',
        reason: 'REFUND'
      };

      this.balanceAdjustmentService.create(balanceAdjustment).then((response: any) => {
        const balanceAdjustmentId = response.headers.location.split('/').pop();
        const timeoutId = setInterval(() => {
          this.balanceAdjustmentService.getBalanceAdjustment(balanceAdjustmentId).then((response) => {
            if (response.balanceAdjustment.status !== 'PENDING') {
              clearInterval(timeoutId);

              const message = response.balanceAdjustment.status === <any> 'SUCCESSFUL' ? 'CHARGE_ACCOUNTS.REMOVE_CREDIT_SUCCESSFUL' :
                'CHARGE_ACCOUNTS.REMOVE_CREDIT_FAILED';

              this.userMessagesService.showToast(this.$translate.instant(message));

              this.chargeAccountService.getChargeAccount(this.chargeAccount.id).then((response) => {
                this.chargeAccount = response.chargeAccount;
                this.$rootScope.showSpinner = false;
              });
            }
          });
        }, 1000);
      });
    });
  };

  /**
 * A method that recovers debt the charge account
 */
  public showDebtRecoveryDialog = () => {
    this.dialogService.showDebtRecoveryDialog(this.chargeAccount.outstandingDebt.amount).then(() => {
      this.$rootScope.showSpinner = true;

      this.debtRecoveryService.recoverDebtForChargeAccount(this.chargeAccount.id).then(() => {
        setTimeout(() => {
          this.$rootScope.showSpinner = false;
          this.userMessagesService.showToast(this.$translate.instant('CHARGE_ACCOUNTS.DEBT_RECOVERY_IN_PROGRESS'));
        }, 3000);
      });
    });
  };

  /**
  * A method that shows the dialog displaying auto top up details
  */
  public showAutoTopUpDialog = () => {
    this.dialogService.showDialog(
      'Auto Top Up Details',
      'auto-top-up-dialog.html',
      this.autoTopupRules,
      'auto-top-up-dialog').then(() => { });
  }

  /**
  * A method that shows the dialog that allows the user to delete an auto top up
  */
  public showDeleteAutoTopUpDialog = () => {
    this.dialogService.showDialog(
      'Confirm cancel of auto top up',
      'auto-top-up-dialog-delete.html',
      this.autoTopupRules,
      'auto-top-up-dialog-delete').then(() => {
        this.deleteAutoTopup(this.autoTopupRules.autoTopupId).then(() => {
          this.autoTopupStatus = 'AUTO_TOP_UP_STATUS.DISABLED';
        });
      });
  }
  /**
  * A method that shows the dialog that allows a charge account to be topped up
  */
  public showTopUpDialog = () => {
    this.dialogService.showTopUpDialog().then((topupData: InterACT.Interfaces.ITopupData) => {
      this.$rootScope.showSpinner = true;

      const externalTopUp = this.externalTopUpsService.getNewExternalTopUp(topupData, this.chargeAccount);
      this.externalTopUpsService.createExternalTopUp(externalTopUp).then((response: any) => {
        const externalTopUpId = response.headers.location.split('/').pop();
        const timeoutId = setInterval(() => {
          this.externalTopUpsService.getExternalTopUp(externalTopUpId).then((response) => {
            if (response.externalTopUp.status !== 'PENDING') {
              clearInterval(timeoutId);

              const message = response.externalTopUp.status === 'SUCCESS' ? 'CHARGE_ACCOUNTS.TOP_UP_SUCCESSFUL' :
                'CHARGE_ACCOUNTS.TOP_UP_FAILED';

              this.userMessagesService.showToast(this.$translate.instant(message));

              this.chargeAccountService.getChargeAccount(this.chargeAccount.id).then((response) => {
                this.chargeAccount = response.chargeAccount;
                this.$rootScope.showSpinner = false;
              });
            }
          });
        }, 1000);
      });
    });
  };



  /**
   * A method that navigates to the customers smart media page
   */
  public goToCustomerSmartMediaPage = () => {
    this.$state.go('customer.smartmedia.list', { customerId: this.chargeAccount.customer.link.split('/').pop() });
  };

  /**
   * A method that navigates to the customers details page
   */
  public goToCustomerDetailsPage = () => {
    this.$state.go('customer.details', { customerId: this.chargeAccount.customer.link.split('/').pop() });
  };

  /**
 * A method that returns the ISRN of the customers usage token or 'Not Associated' if none exists'
 */
  public getIsrn = () => {
    const notAssociated = 'Not Associated';

    if (this.chargeAccount.usageTokens.length === 0) {
      return notAssociated;
    }

    if (!this.chargeAccount.usageTokens[ 0 ].mediaLink || !this.chargeAccount.usageTokens[ 0 ].mediaLink.reference) {
      return notAssociated;
    }

    const reference = this.chargeAccount.usageTokens[ 0 ].mediaLink.reference;
    if (reference === 'unknown') {
      return notAssociated;
    }

    return reference;
  }

  /**
   * A method that gets fee and deposit amounts from the charge account and adds them toghether
   */
  public getBufferAmount = () => {
    var feeAmount = 0;
    var depositAmount = 0;

    if (this.chargeAccount && this.chargeAccount.feeAmount !== undefined) {
      feeAmount = this.chargeAccount.feeAmount;
    }

    if (this.chargeAccount && this.chargeAccount.depositAmount !== undefined) {
      depositAmount = this.chargeAccount.depositAmount;
    }

    return ((feeAmount + depositAmount) / 100).toFixed(2);
  };

  /**
   * A method that gets the appropriate icon for the customers contact details. email, phone etc
   */
  public getContactDetailsIcon = () => {
    const contactDetails = this.getCustomerContactDetails();

    switch (contactDetails.type) {
      case 'POSTAL':
      case 'EMAIL':
        return 'mail';
      case 'HOME':
      case 'MOBILE':
        return 'phone';

      default:
        return 'phone';
    }
  };

  /**
 * A method that returns the primary contact details for the customer if they exist. Otherwise it returns the first contact details
 * @param customer The customer to get the contact details for
 */
  public getCustomerContactDetails = () => {
    if (!this.customer.contactDetails || this.customer.contactDetails.length === 0) {
      return {
        detail: '',
        type: ''
      };
    }

    const primaryContacts = this.customer.contactDetails.filter((contactDetails) => {
      return contactDetails.primary;
    });

    if (primaryContacts.length > 0) {
      return primaryContacts[ 0 ];
    }

    return this.customer.contactDetails[ 0 ];
  };

  /**
   * A method that calculated the current balance on the charge account
   */
  public getCurrentBalance() {
    return this.chargeAccount.unsettledCharges.amount + this.chargeAccount.outstandingDebt.amount - this.chargeAccount.unsettledRefunds;
  }

  /**
   * A method that gets the mode of a given journey
   * @param journey the journey to get the mode for
   */
  public getJourneyMode(journey: InterACT.Interfaces.Journeys.Journey) {
    if (!journey.journeyLegs || journey.journeyLegs.length === 0) {
      return 'NA';
    }

    const firstJourneyLegMode = journey.journeyLegs[ 0 ].mode;
    const otherModes = journey.journeyLegs.filter((journeyLeg) => {
      return journeyLeg.mode !== firstJourneyLegMode;
    });

    return otherModes.length > 0 ? 'MULTIPLE' : firstJourneyLegMode;
  }

  /**
   * A method that toggles the expansion state for the supplied journey
   * @param journey the journey to toggle the expansion for
   */
  public toggleExpansion = (journey: InterACT.Interfaces.Journeys.Journey) => {
    if (this.expandedItem === journey) {
      this.expandedItem = undefined;
    } else {
      this.expandedItem = journey;
      this.populateJourneyToUsageEventDictionary(journey);
    }
  }

  /**
   * A method that retrieves a given page of journeys
   * @param page the page of journeys to retrieve
   * @param perPage the amount of journeys to retrieve per page
   */
  public getJourneyData() {
    const query = this.queryBuilder.newParam().fieldIs('chargeAccount.link', '/charge-accounts/' + this.chargeAccount.id)
      .sortBy([ {
        columnName: 'startDateTime',
        direction: 'desc'
      } ]).getParam();

    this.journeyService.getList(1, 5, query).then((getJourneysResponse: InterACT.Interfaces.Journeys.JourneysResponse) => {
      this.journeys = getJourneysResponse.journeys;
    });
  }

  /**
   * A method that returns a description of the supplied tap event in the form LOCATION (Type). i.e. Cardiff Central (Entry)
   * @param usageEvent the usageEvent to get the description for
   */
  public getUsageDescription(usageEvent: InterACT.Interfaces.UsageEvents.UsageEvent) {
    const suffix = ' (' + usageEvent.type + ')';

    if (usageEvent.location && usageEvent.destinationLocation) {
      return usageEvent.location.locationName + ' > ' + usageEvent.destinationLocation.locationName;
    }

    if (usageEvent.location) {
      return usageEvent.location.locationName + suffix;
    }

    return usageEvent.destinationLocation.locationName + suffix;
  }

  /**
   * A method that returns true when the auto top up status is enabled.
   */
  public isAutoTopupStatusEnabled() {
    return this.autoTopupStatus === 'AUTO_TOP_UP_STATUS.ENABLED';
  }

  /**
   * A method that returns true when there is a friendly name on the charge account.
   */
  public isAccountNamePresent() {
    return this.chargeAccount.friendlyName !== null && this.chargeAccount.friendlyName !== undefined;
  }

  /**
   * A method that deletes the customer's auto top up rule
   */
  public deleteAutoTopup = (autoTopupId: string) => {
    return this.chargeAccountAutoTopupService.deleteAutoTopup(autoTopupId);
  }

  /**
   * A method that returns a entry location of the supplied journey
   * @param journey the journey to get the entry location for
   */
  public getStartLocation(journey) {
    if (journey.startLocation) {
      return journey.startLocation.transportLocation.locationName;
    }
    return 'N/A';
  }

  /**
   * A method that returns a destination of the supplied journey
   * @param journey the journey to get the destination for
   */
  public getEndLocation(journey) {
    if (journey.endLocation) {
      return journey.endLocation.transportLocation.locationName
    };
    return 'N/A';
  }


  /**
   * A method that returns a operator of the supplied journey
   * @param journey the journey to get the operator number for
   */
  public getOperator(journey: InterACT.Interfaces.Journeys.Journey) {
    if (journey.operator) {
      return journey.operator.name;
    }

    return 'Unknown';
  };

  /**
   * A method that returns a boolean value which indicates if a user can remove credit
  */
     public canRemoveCredit() {
      if (!this.userService.permissions || !this.userService.permissions.ui[ 'remove-credit' ]) {
        return false;
      }
  
      return this.userService.permissions.ui[ 'remove-credit' ];
    }
  

  /**
   * A method that returns a boolean value which indicates if a user can view an auto top up status
  */
  public canViewAutoTopupStatus() {
    if (!this.userService.permissions || !this.userService.permissions.autotopups) {
      return false;
    }

    return this.userService.permissions.autotopups.canRead;
  }

  /**
   * A method that returns a boolean value which indicates if a user can delete an auto top up status
  */
  public canDeleteAutoTopupStatus() {
    if (!this.userService.permissions || !this.userService.permissions.autotopups) {
      return false;
    }

    return this.userService.permissions.autotopups.canDelete;
  }

  /**
   * A method that returns a boolean value which indicates if a user can update a charge account
  */
 public canUpdateChargeAccount() {
  if (!this.userService.permissions || !this.userService.permissions.chargeaccounts) {
    return false;
  }

  return this.userService.permissions.chargeaccounts.canUpdate;
}

  /**
   * A method that returns a service number of the supplied journey
   * @param journey the journey to get the service number for
   */
  public getServiceNumber(journey: InterACT.Interfaces.Journeys.Journey) {
    if (journey.service) {
      return journey.service.regNumber;
    }

    return 'Unknown';
  };

  /**
   * A method that returns a direction of travel (DOT) of the supplied journey
   * @param journey the journey to get the DOT for
   */
  public getDirectionOfTravel(journey: InterACT.Interfaces.Journeys.Journey) {
    if (journey.service) {
      if (journey.service.direction) {
        return 'ROUTE_DIRECTION.' + journey.service.direction;
      }
      return 'ROUTE_DIRECTION.ALL';
    }
    return 'Unknown';
  };

  /**
   * A method to format the full name of a customer including the title
   */
  public getFullName() {
    const title = this.customer.title ? `${ this.$translate.instant("CUSTOMER_DETAIL." + this.customer.title.toUpperCase()) } ` : "";
    const forename = this.customer.forename ? `${ this.customer.forename } ` : "";
    const surname = this.customer.surname ? this.customer.surname : "";
    return `${ title }${ forename }${ surname }`
  }

  /**
   * A method that shows a dialog containing the latest Usage Token ID
   */
  public showUsageTokenId = async () => {
    try {
      await this.dialogService.showDialog(
        this.$translate.instant("BARCODE_TOKEN_ID"),
        "barcode-token-dialog.html",
        this.latestUsageTokenId,
        undefined
      );
    } catch (e) {
      return e;
    }
  }

  /**
   * A method that shows a dialog to add or edit an account name on the charge account
   */
  public showAccountNameDialog = () => {
    var friendlyName = this.isAccountNamePresent() ? this.chargeAccount.friendlyName : "";
    var header = this.isAccountNamePresent() ? 'ACCOUNT_NAME_DIALOG.EDIT_ACCOUNT_NAME_HEADER' : 'ACCOUNT_NAME_DIALOG.ADD_ACCOUNT_NAME_HEADER';
    this.dialogService.showAccountNameDialog(friendlyName, header).then((data: { accountName: string }) => {
      this.$rootScope.showSpinner = true;
      this.chargeAccount.friendlyName = data.accountName;
      this.chargeAccountService.updateChargeAccount(this.chargeAccount.id, this.chargeAccount).then((response: any)=>{
        this.chargeAccount.friendlyName;
        this.$rootScope.showSpinner = false;
      });
    });
  }

  /**
   * A method that decides to display the option to either add or edit an account name 
   */
  public getManageAccountNameButtonText(){
    return this.isAccountNamePresent() ? 'CHARGE_ACCOUNTS.EDIT_ACCOUNT_NAME' : 'CHARGE_ACCOUNTS.ADD_ACCOUNT_NAME'
  }

  /**
   * Queries the secure usage token service to find the latest secure usage token available
   *
   * @returns the latest Secure Usage Token ID
   */
  private getLatestUsageToken() {
    const query = this.queryBuilder
      .newParam()
      .statusIs('VALID')
      .and()
      .fieldIs('chargeAccount.link', `/charge-accounts/${ this.chargeAccount.id }`)
      .sortBy([ { columnName: 'expiry', direction: 'desc' } ])
      .getParam();

    this.secureUsageTokenService.getSecureUsageTokens(1, 1, query).then((secureUsageTokens) => {
      if (secureUsageTokens.length === 0) {
        this.latestUsageTokenId = undefined;
      }

      this.latestUsageTokenId = secureUsageTokens[ 0 ].secureUsageToken.id;
    }).catch(() => {
      this.latestUsageTokenId = undefined;
    })
  }

  private getChargeAccountDeviceMapping() {
    const rolePermissions = this.userService.permissions['chargeaccountdevicemappings'];
    this.displayDevice = rolePermissions && rolePermissions.canRead;
    if (this.displayDevice) {
      this.chargeAccountDeviceMappingsService
      .getChargeAccountDeviceMappings(1, 1, `chargeAccount.link='/charge-accounts/${this.chargeAccount.id}' and status='ACTIVE' and not exists replacedBy sortBy created desc`)
      .then(response => this.chargeAccountDeviceMapping = response.shift());
    }
  }

  private getAccountType() {
    const chargeAccountLinkParts = this.chargeAccount.type.link.split('/');
    if (chargeAccountLinkParts.length < 5) {
      this.chargeAccountType = "UNKNOWN";
      return;
    }

    return this.productService.getProduct(chargeAccountLinkParts[ 2 ], parseInt(chargeAccountLinkParts[ 4 ]), {}).then((product) => {
      this.chargeAccountType = product.fields.type || "UNKNOWN";
    })
  }

  /**
   * A method that retrieves, and stores in a dictionary, the usage events related to a journey
   * @param journey the journey to get and store the usage events for
   */
  private populateJourneyToUsageEventDictionary(journey: InterACT.Interfaces.Journeys.Journey) {
    if (!journey.usageEvents || journey.usageEvents.length === 0) {
      return;
    }

    if (this.journeyToUsageEventDictionary[ journey.id ]) {
      return;
    }

    const usageEventIds = journey.usageEvents.map((usageEvent) => {
      return usageEvent.link.split('/').pop();
    });

    const query = this.queryBuilder.newParam().fieldIn('id', usageEventIds).sortBy([ {
      columnName: 'timestamp',
      direction: 'desc'
    } ]).getParam();
    this.usageEventService.getList(1, usageEventIds.length, query).then((response) => {
      this.journeyToUsageEventDictionary[ journey.id ] = response.usageEvents.map((usageEventWithMeta) => { return usageEventWithMeta.usageEvent; });
    });
  }

  /**
   * A method which is used to get a customers photo
   */
  private getCustomerPhoto = () => {
    this.photoService.getCustomerPhoto(this.customer.id, this.customer.currentPhotoId).then((response) => {
      const blob = new Blob([ response ]);

      try {
        this.customerPhoto = (this.$window.URL || (<any>this.$window).webkitURL).createObjectURL(blob);
      } catch (err) {
        console.log('An issue occurred creating the customer photo: ' + err);
      }
    });
  }

  /**
   * A method that gets called during controller instantiation
   */
  private async activate() {
    this.getAccountType();

    this.getAutoTopupStatus();

    this.setDisplayLastPaymentActivity();
    this.setDisplayLastBalanceActivity();

    this.ACTToolbarService.getToolbar('primary').then(async (toolbar) => {
      this.getLastAction();
      this.getJourneyData();

      const customerId = this.chargeAccount.customer ? this.chargeAccount.customer.link.split('/').pop() : undefined;

      if (customerId) {
        this.retrievingCustomer = true;
        this.customerService.getCustomer(customerId).then((customer) => {
          this.customer = customer;
          this.retrievingCustomer = false;

          if (customer.currentPhotoId) {
            this.getCustomerPhoto();
          }

          const customerName: string = this.getFullCustomerName(customer);
          this.setBreadcrumbs(customerName, 'charge-account-summary');
          this.setToolbar(customerName);
        });
      } else {
        this.setBreadcrumbs('ANONYMOUS_CHARGE_ACCOUNT', 'charge-account-summary');
        this.setToolbar('ANONYMOUS_CHARGE_ACCOUNT');
      };
      this.getPaymentToken();
      this.getLatestUsageToken();
      this.getChargeAccountDeviceMapping();
      if (this.chargeAccount.paymentToken.length === 0) {
        return;
      }

      this.getMostRecentPayment(this.chargeAccount.paymentToken[ 0 ].link);
    });
  }

  private getMostRecentPayment(paymentTokenLink: string) {
    const query = this.queryBuilder.newParam().fieldIs('paymentToken.link', paymentTokenLink).sortBy([ {
      columnName: 'created',
      direction: 'desc'
    } ]);

    this.paymentService.getPaymentHistory(1, 1, query.getParam()).then((response) => {
      if (response.paymentRequests.length === 0) {
        return;
      }

      this.mostRecentPayment = response.paymentRequests[ 0 ];
    });
  }

  /**
   * A method that retrieves a payment token for the charge account
   */
  private getPaymentToken() {
    if (this.chargeAccount.paymentToken && this.chargeAccount.paymentToken.length > 0) {
      const paymentTokenLinkParts = this.chargeAccount.paymentToken[ 0 ].link.split('/');
      if (paymentTokenLinkParts.length < 3) {
        return;
      }

      const paymentTokenId = paymentTokenLinkParts[ 2 ];

      return this.paymentService.getPaymentToken(paymentTokenId).then((response) => {
        this.paymentToken = response.paymentToken;
        this.lastModifiedDateOfPaymentToken = response.meta.lastModified;
      });
    }
  }

  private getLastAction() {
    this.chargeAccountActionsService.getLastAction(this.chargeAccount.id).then((response) => {
      this.lastActionWithMeta = response.chargeAccountActions.length > 0 ? response.chargeAccountActions[ 0 ] : undefined;
    });
  }

  private setDisplayLastBalanceActivity(): void {
    this.displayLastBalanceActivity = this.userService.permissions.ui
      ? Object.keys(this.userService.permissions.ui).some((perm: string) =>
        perm.toLowerCase() === 'charge-account-tabs-statement'
        && this.userService.permissions.ui[ perm ].canAccess)
      : false;
  }

  private setDisplayLastPaymentActivity(): void {
    this.displayLastPaymentActivity = this.userService.permissions.ui
      ? Object.keys(this.userService.permissions.ui).some((perm: string) =>
        perm.toLowerCase() === 'charge-account-tabs-payments'
        && this.userService.permissions.ui[ perm ].canAccess)
      : false;
  }

  private getAutoTopupStatus() {
    this.chargeAccountAutoTopupService
      .getAutoTopups(1, 15, `chargeAccount.link=/charge-accounts/${ this.chargeAccount.id }`)
      .then((response) => {
        if (response && response.autoTopups.length === 0) {
          this.autoTopupStatus = 'AUTO_TOP_UP_STATUS.DISABLED';
        } else {
          const autoTopup = response.autoTopups[ 0 ].autoTopup;

          this.paymentService
            .getPaymentToken(autoTopup.paymentToken.link.split('/').pop()).then(paymentTokenResponse => {
              const { accountNumber } = paymentTokenResponse.paymentToken;
              this.autoTopupRules = {
                threshold: autoTopup.autoTopupThreshold,
                topupAmount: autoTopup.amount,
                lastFourDigitsOfCardNumber: '**** ' + accountNumber.substr(accountNumber.length - 4, accountNumber.length),
                autoTopupDate: response.autoTopups[ 0 ].meta.created,
                autoTopupId: autoTopup.id
              }
              this.autoTopupStatus = response.autoTopups[ 0 ].autoTopup.enabled
                ? 'AUTO_TOP_UP_STATUS.ENABLED'
                : 'AUTO_TOP_UP_STATUS.DISABLED'
            })
        }
      }).catch(() => {
        this.autoTopupStatus = 'AUTO_TOP_UP_STATUS.DISABLED';
      });
  }
}
